import { render, staticRenderFns } from "./MarketingExpiredVouchers.vue?vue&type=template&id=10e00f83&scoped=true"
import script from "./MarketingExpiredVouchers.vue?vue&type=script&lang=js"
export * from "./MarketingExpiredVouchers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10e00f83",
  null
  
)

export default component.exports